import React, { Suspense, useEffect, useState } from 'react';
import ReactGA from 'react-ga';
import {
  Route,
  Routes,
  BrowserRouter,
  // useNavigate
} from 'react-router-dom'
import 'bootstrap/dist/js/bootstrap.min.js'
import {
  liff
} from './libs'
import {
  verifyAcessToken
} from './hooks/auths'
import usePrivacy from ".//hooks/privacy/privacy";

import Layout from './components/Layout'

import 'bootstrap/dist/css/bootstrap.min.css'
import './App.css';

import Loading from './components/Loading';
import Payment from './pages/Payment';
import BookingWithGoogleForm from './pages/BookingWithGoogleForm';
import EmptySeats from './pages/EmptySeats';
import PreBookingList from './pages/PreBookingList';
import LanguageSwitcher from './components/LanguageSwitcher';
import Questionnaire from './pages/Questionnaire';
import Reward from './pages/Reward';
import WhiteListFailed from './pages/WhiteListFailed';
import VerifyReward from './pages/VerifyReward';

const Home = React.lazy(() => import('./pages/Home'))
const Booking = React.lazy(() => import('./pages/Booking'))
const PrivacyNotice = React.lazy(() => import('./pages/PrivacyNotice'))
const History = React.lazy(() => import('./pages/History'))
const NoMatch = React.lazy(() => import('./pages/NoMatch'))

ReactGA.initialize(process.env.REACT_APP_GA_ID)
ReactGA.pageview(window.location.pathname + window.location.search);

function App() {
  let { privacy, getPrivacyConsent } = usePrivacy();
  let [isLoading, setIsLoading] = useState(true)

  const isPolicyEnable = () => {
    let isPolicy = true
    let pathname = window.location.pathname
    let pathList = [
      '/reward',
      '/rewards',
      '/questionnaire'
    ]
    for (let path of pathList) {
      if (pathname.includes(path)) isPolicy = false
    }

    console.log(isPolicy)
    return isPolicy
  }

  const checkLiffLogin = async () => {
    // console.log(process.env.REACT_APP_ENV)
    // console.log("LIFF Start")
    const l = await liff.initLiff()
    // console.log(l.isLoggedIn())
    if (!l.isLoggedIn()) l.login()
    else {
      const accessToken = l.getAccessToken()
      localStorage.setItem('actk', accessToken)
      const response = await verifyAcessToken()
      localStorage.setItem('userID', response.data.userId)
      localStorage.setItem('isDriver', false)
      if (response.data.isDriver) localStorage.setItem('isDriver', response.data.isDriver)
      // console.log(isPolicyEnable())
      if (isPolicyEnable()) getPrivacyConsent()
      setIsLoading(false)
    }
  }

  useEffect(() => {
    // console.log("Privacy")
    // console.log(privacy)
    if (privacy.status === "GET_SUCCESS") {
      // console.log(privacy)
    }
  }, [privacy.status]);

  useEffect(() => {
    if (process.env.REACT_APP_ENV === "prod") {
      ReactGA.pageview(window.location.pathname + window.location.search);
    }
    checkLiffLogin()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (isLoading) return <Loading />
  else
    return (
      <div className="App">
        <BrowserRouter>
          <div>
            <div style={{ display: "none" }}>
              <LanguageSwitcher />
            </div>
            <Routes>
              <Route path="/" element={<Layout />}>
                <Route index element={
                  <Suspense fallback={<Loading />}>
                    <Home />
                  </Suspense>
                } >
                </Route>
                <Route path="booking/:id" element={
                  <Suspense fallback={<Loading />}>
                    <Booking />
                  </Suspense>
                } >
                </Route>
                <Route path="empty-seats/check/:id" element={
                  <Suspense fallback={<Loading />}>
                    <EmptySeats />
                  </Suspense>
                } ></Route>
                <Route path="booking/v2/:id" element={
                  <Suspense fallback={<Loading />}>
                    <BookingWithGoogleForm />
                  </Suspense>
                } ></Route>
                <Route path="payment/:orderNumber" element={
                  <Suspense fallback={<Loading />}>
                    <Payment />
                  </Suspense>
                } >
                </Route>
                <Route path="ticket" element={
                  <Suspense fallback={<Loading />}>
                    <History />
                  </Suspense>
                } >
                </Route>
                <Route path="privacy" element={
                  <Suspense fallback={<Loading />}>
                    <PrivacyNotice />
                  </Suspense>
                } >
                </Route>
                <Route path="whitelist/no-access/:id" element={
                  <Suspense fallback={<Loading />}>
                    <WhiteListFailed />
                  </Suspense>
                } >
                </Route>
                <Route path="pre-booking" element={
                  <Suspense fallback={<Loading />}>
                    <PreBookingList />
                  </Suspense>
                } >
                </Route>
                <Route path="questionnaire/:id" element={
                  <Suspense fallback={<Loading />}>
                    <Questionnaire />
                  </Suspense>
                } >
                </Route>
                <Route path="rewards" element={
                  <Suspense fallback={<Loading />}>
                    <Reward />
                  </Suspense>
                } >
                </Route>
                <Route path="reward/verify" element={
                  <Suspense fallback={<Loading />}>
                    <VerifyReward />
                  </Suspense>
                } >
                </Route>
              </Route>
              <Route path='*' element={
                <Suspense fallback={<Loading />}>
                  <NoMatch />
                </Suspense>
              } />
            </Routes>
          </div>
        </BrowserRouter>
      </div>
    );
}

export default App;
